const SMS_TEMPLATE_NAME = Object.freeze({
  parking: 'parking',
  policy: 'cancellation_policy',
  consultation: 'consultation_form',
  custom: 'custom',
});

export default SMS_TEMPLATE_NAME;
